import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";

type _ClickbleOnTap = () => void;

export interface ClickbleProps extends BaseUIProps {
  key?: string;
  onTap?: _ClickbleOnTap;
  child?: ReactNode;
}

class _ClickbleState extends ObservableComponent<ClickbleProps> {
  public constructor(props: ClickbleProps) {
    super(props);

    this.initState();
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {}
  public render(): ReactNode {
    return ui.Container({
      child: this.props.child,
      onTap: (e) => {
        e.stopPropagation();

        this.tap();
      },
      className: ui.join(this.props.className, "Clickble x051"),
      ...copyBaseUIProps(this.props),
    });
  }
  public tap = (): void => {
    this.onTap();
  };
  public get onTap(): _ClickbleOnTap {
    return this.props.onTap;
  }
  public get childPresent(): boolean {
    return this.props.child != null;
  }
  public get child(): ReactNode {
    return this.props.child;
  }
}
export default function Clickble(props: ClickbleProps) {
  return React.createElement(_ClickbleState, props);
}
